var _defs, _rect, _polygon, _text, _g, _text2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoVillow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 413.79 136.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke-width: .43px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #0772ba;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3 {\n        font-size: 110.87px;\n      }\n\n      .cls-3, .cls-2, .cls-4 {\n        fill: #0171ba;\n      }\n\n      .cls-3, .cls-5 {\n        font-family: Arial-BoldMT, Arial;\n        font-weight: 700;\n      }\n\n      .cls-2 {\n        stroke-width: 1px;\n      }\n\n      .cls-4 {\n        font-family: AdelleSansDevanagari-Regular, 'Adelle Sans Devanagari';\n        font-size: 5.22px;\n      }\n\n      .cls-5 {\n        fill: #fff;\n        font-size: 106.65px;\n        letter-spacing: 0em;\n      }\n\n      .cls-6 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-7 {\n        letter-spacing: 0em;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 25.22,
    y: 44.47,
    width: 67.92,
    height: 50.17
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "59.18 15.88 26.05 43.63 92.32 43.63 59.18 15.88"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(101.64 95.11) scale(.95 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 0,
    y: 0
  }, "Z"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 72.06,
    y: 0
  }, "illow"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 410.83,
    cy: 34.83,
    rx: 2.74,
    ry: 2.52
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(409.04 36.62) scale(1.09 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(33.72 74.67) rotate(57.13) scale(.59 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "z"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVillow);
export default __webpack_public_path__ + "static/media/Logo-Villow.c98bee004fdceda1a1a477c1646ea6b7.svg";
export { ForwardRef as ReactComponent };